import React, { createElement, useEffect, useState } from 'react';
import { InputNumber, Form, Col } from 'antd';
import { generateRules } from '../../../utils/index';
import './index.scss';
import ErrorBoundary from '../../common/errorBoundary';
import ErrorComponent from '../../common/errorComponent';
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const FormNumber = (props, ref) => {
    const { isNecessary, verifytext, title, __id, rules, status, span, column, ...other } = props;
    const [error, setError] = useState(false);
    const [errmsg, setErrmsg] = useState(null);
    const [rule, setRule] = useState([]);
    useEffect(() => {
        setError(false);
        try {
            setRule(generateRules(rules, 'number'));
        }
        catch (error) {
            console.log(error);
            setError(true);
            setErrmsg('校验规则初始化出错,检查配置或更新组件');
        }
    }, [rules]);
    return (createElement(ErrorBoundary, null, error ? (createElement(ErrorComponent, { ref: ref, errmsg: errmsg })) : (createElement(Col, { span: column || span },
        createElement("div", { ref: ref, className: "base_bg" },
            createElement(Form.Item, { label: title || '数值', name: __id || props.componentId, rules: rule },
                createElement(InputNumber, Object.assign({ style: { width: '100%' }, disabled: status === 'readonly' || urlParams.get('edit') === '3' }, other, props))))))));
};
export default React.forwardRef(FormNumber);
